import { useMemoSelector } from '@spa/redux/hooks'
import UnpublishButton from '@spa/scenes/Plannings/Navigation/UnpublishButton/UnpublishButton'
import React from 'react'
import type { FC } from 'react'

import {
  getParams,
  weeklyschedulesSelectors,
  teamsSelectors
} from '../../../redux/selectors'
import Calendar from '../../Calendar/Calendar'

import styles from './TeamHeader.module.css'

type Props = {
  teamId: number
}
const TeamHeaderComponent: FC<Props> = ({ teamId }) => {
  const { date } = useMemoSelector(getParams)

  const team = teamsSelectors.useGetCachedById(teamId)
  const weeklyschedule = useMemoSelector(state =>
    weeklyschedulesSelectors.getWeeklyscheduleFromTeamId(state, {
      // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
      date,
      teamId
    })
  )

  return (
    <Calendar.Row noBorder secondary>
      <Calendar.Cell secondary>
        <div className={styles.Content}>
          <div>{team?.name}</div>
          <div>
            {weeklyschedule?.permissions?.can_unpublish &&
              weeklyschedule?.published && (
                <UnpublishButton weeklyscheduleId={weeklyschedule.id} />
              )}
          </div>
        </div>
      </Calendar.Cell>
    </Calendar.Row>
  )
}
export const TeamHeader = React.memo(TeamHeaderComponent)
